
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { checkIfLoggedIn, checkUserRole } from "../../utils/Authenticate";

export default function PrivateRoute({ children, role }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [authorized, setAuthorized] = useState(null);

  useEffect(() => {
    (async () => {
      const loggedIn = await checkIfLoggedIn(dispatch);
      if (!loggedIn) {
        localStorage.clear();
        navigate("/", { replace: true });
        setAuthorized(false);
      } else {
        // ✅ role-based protection
        if (role && checkUserRole() !== role) {
          navigate("/", { replace: true });
          setAuthorized(false);
        } else {
          setAuthorized(true);
        }
      }
    })();
  }, [dispatch, navigate, role]);

  if (authorized === null) {
    return <div>Loading...</div>; // optional loader/spinner
  }

  return authorized ? children : null;
}
// import React from 'react'
// import { checkIfLoggedIn } from '../../utils/Authenticate'
// import { Route, Redirect, useNavigate } from 'react-router-dom'

// export default function PrivateRoute({ props, children, ...rest }) {
//     const navigate = useNavigate()
//     const loggedIn = checkIfLoggedIn()

//     Promise.resolve(loggedIn).then(value => {
//         if (value === false) {
//             localStorage.clear()
//             navigate('/')
//         }
//     })

//     return (
//         <Route
//             {...rest}
//             render={({ location }) =>
//                 // loggedIn && loggedIn.role === rest.role ? (
//                 loggedIn ? (
//                     children
//                 ) : (
//                     <Redirect
//                         to={{
//                             pathname: "/",
//                             from: location
//                         }}
//                     />
//                 )
//             }
//         />
//     )
// }